import { difference } from 'lodash';
import { makeAutoObservable } from 'mobx';

export class DisabledCategories {
  public disabledIds: string[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  private _disable(id: string) {
    if (this.isDisabled(id)) {
      return;
    }

    this.disabledIds = [...this.disabledIds, id];
  }

  private _enable(id: string) {
    this.disabledIds = difference(this.disabledIds, [id]);
  }

  public isDisabled(id: string) {
    return this.disabledIds.includes(id);
  }

  public toggle(id: string) {
    if (this.isDisabled(id)) {
      this._enable(id);
      return;
    }

    this._disable(id);
  }
}
